import React, { useState } from "react";
import iconRegistrasi from "../../../assets/Form/ic_white_register.png";
import { ProductItem } from "../../../domain/entities/ProductItem";

interface CardProps {
    productItems: ProductItem[];
    onButtonClick: (productId: number, price: number) => void;
}

const ProductBorderLineComponents: React.FC<CardProps> = ({
    productItems,
    onButtonClick,
}) => {

    const [activeCard, setActiveCard] = useState<number | null>(null);

    const handleButtonClick = (productId: number, price: number) => {
        onButtonClick(productId, price);
        setActiveCard(productId);
    }

    return (
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-2 gap-6">
            {productItems.map((card) => (
                <div className="bg-white border shadow-lg rounded-2xl p-6 md:p-10 flex flex-col gap-2 max-w-md md:max-w-3xl">
                    {/* Title Section */}
                    <h2 className="text-lg md:text-xl font-bold text-pink-700 text-start font-poppins">
                        {card.name}
                    </h2>

                    {/* Description */}
                    <p className="text-gray-700 text-sm md:text-sm text-justify font-poppins">
                        {card.description}
                    </p>

                    {/* Button */}
                    <button
                        className={`self-start ${
                    activeCard === card.id ? "bg-pink-800 text-white" : "bg-gray-300 text-white"
                    } px-4 py-2 rounded-md text-sm font-semibold shadow hover:bg-pink-800 transition flex items-center gap-2 font-poppins`}
                        onClick={() => handleButtonClick(card.id, card.price)}
                    >
                        <img src={iconRegistrasi} alt="Icon Registrasi" className="w-4 h-4" />
                        <span>Pilih</span>
                    </button>
                </div>
            ))}
        </div>
    );
};

export default ProductBorderLineComponents;